<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter justify-center items-center">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="px-8 pt-8 login-tabs-container">

                <div class="vx-card__title mb-5">
                  <h4 class="mb-4">Login</h4>
                  <p>Welcome back, please login to your account.</p>
                </div>
                <div class="my-5">
                  <login-jwt></login-jwt>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>


<script>
import { serverError } from '../../../utils/errorsUtils'
import LoginJwt from './LoginJWT.vue'
import LoginFirebase from './LoginFirebase.vue'
import LoginAuth0 from './LoginAuth0.vue'
import { isLoginAndHasToken } from '../../../utils/localStorage'

export default {
  components: {
    LoginJwt,
    LoginFirebase,
    LoginAuth0
  },
  computed: {
    isLogin () {
      if (isLoginAndHasToken()
      ) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    generateGuestToken () {
      try {
        // console.log(localStorage)
        const that = this
        window.OneSignal.getUserId()
          .then(function (id) { 
            // console.log(id)
            that.$store.dispatch('loginManagement/generateGuestToken', {id})
              .then(() => { 
                that.$vs.loading.close()
              })
              .catch((err) => {
                console.log(err)
                serverError(that)
                that.$vs.loading.close()
              })
          })
          .catch((err) => {
            console.log(err)
            serverError(that)
            that.$vs.loading.close()
          })
      } catch (err) {
        console.log(err)
        // sending dummy because one signal failed
        this.$store.dispatch('loginManagement/generateGuestToken', {id:'dummy'})
          .then(() => { 
            this.$vs.loading.close()
          })
          .catch((err) => {
            console.log(err)
            serverError(this)
            this.$vs.loading.close()
          })
      }
    }
  },
  created () {
    // console.log(this.$route)
    // console.log('this.isLogin', this.isLogin)
    if (this.isLogin) {
      // this means user is already logged in
      // update state
      this.$store.dispatch('loginManagement/updateLoginAndTokenFromLocalStorage')
        .then(response => {
          // console.log(response)
          if (!response) {
            this.generateGuestToken()
            return
          }    
          // console.log(this.$route)
          if (!this.$route.query.to) {
            this.$router.push('/dashboard/analytics')
          } else {
            this.$router.push(this.$route.query.to)
          }
        })
        .catch((err) => {
          console.log(err)
          this.generateGuestToken()
        })
    } else {
      this.generateGuestToken()
    }
  }
}
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
</style>
